import styled from "styled-components";

import { MobileOverlay, Sidebar } from "components/molecules/nav/styles/nav.styles";

export const NavSectionBody = styled.div.attrs({
  className: "fixed left-4 top-4 z-50 lg:hidden",
})``;

export const NavMobileOverlay = styled(MobileOverlay).attrs({ className: "lg:hidden" })``;

export const NavSidebar = styled(Sidebar).attrs({
  className:
    "supports-[height:100dvh]:h-[100dvh] supports-[height:100dvh]:min-h-[100dvh] supports-[height:100dvh]:max-h-[100dvh]",
})``;

export const NavIllustrationImage = styled.img`
  height: 3rem;
  object-fit: contain;
  width: 3rem;
`;

export const NavTextGroup = styled.div`
  min-width: 0;
  padding-top: 0.125rem;
`;

export const NavEyebrowText = styled.p`
  color: var(--brand-highlight);
  font-family: var(--font-anonymous, inherit);
  font-size: 0.75rem;
  letter-spacing: 0.3em;
  line-height: 1;
  text-transform: uppercase;
`;

export const NavPageHeading = styled.h1`
  color: var(--brand-ink);
  font-size: 1.625rem;
  font-weight: 600;
  line-height: 1;
  margin-top: 0.25rem;

  @media (min-width: 1024px) {
    font-size: 1.8125rem;
  }
`;
